module.exports = "<app-simple-table [dataService]=\"dataService\"></app-simple-table>\n"